/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ERC1155Base__factory } from "./ERC1155Base__factory";
export { ERC1155BaseInternal__factory } from "./ERC1155BaseInternal__factory";
export { IERC1155Base__factory } from "./IERC1155Base__factory";
export { IERC1155BaseInternal__factory } from "./IERC1155BaseInternal__factory";
